import { Injectable } from "@angular/core";

import { GlobalCfgService } from "./globalcfg.service";
import { environment } from "../environments/environment";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PrintService {

  constructor(
    private http: HttpClient,
    private globalCfgService: GlobalCfgService
  ) { }

  getPrintFormats() {
    return this.http.get(
      environment.apiurl +
      "/PrintFormats/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      JSON.stringify({
          order: 'name ASC'
      })
    );
  }

  getHtmlStr(pf, data) {
    var htmlStr = window['ejs'].render(pf.tpl, {labels: data});
    return htmlStr;
  }

}